import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '../helpers/ApiClient';

export const productService = {
    getProducts,
    addProduct,
    deleteProduct,
    updateProduct,
    addOrUpdateProductBatch,
    deleteProductBatch
}

function getProducts(){
    return apiClient.get('/product', {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}

function addProduct(product){
    return apiClient.post(`/product`, product, {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}

function deleteProduct(product) {
    const obj = [product.productId];

    return apiClient.delete(`/product`, {
        headers: authHeader(),
        data: obj
    })
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function deleteProductBatch(productsIds){
    return apiClient.delete(`/product`, {
        headers: authHeader(),
        data: productsIds
    })
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function updateProduct(product){
    return apiClient.patch(`/product/${product.productId}`, product, {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}

function addOrUpdateProductBatch(payload){
    return apiClient.post(`/product/batch`, payload, {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}
